<template>
  <div :class="classes">
    <pt-form-item label="检测平台名称" :required="true" labelWidth="110px">
      <el-input v-model="form.name" name="name" v-validate="'required'" data-vv-as="检测平台名称" :disabled="disabled"></el-input>
    </pt-form-item>
    <pt-form-item label="检测周期" labelWidth="110px" :required="true">
      <el-input v-model="form.cycle" class="small-input" name="cycle" v-validate="'required'" data-vv-as="检测周期"></el-input>
      <el-radio-group v-model="form.dayType" class="marginLeft">
        <el-radio label="NATURAL_DAY">自然日</el-radio>
        <el-radio label="WORK_DAY">工作日</el-radio>
      </el-radio-group>
    </pt-form-item>
  </div>
</template>

<script>
import formMixins from 'mixins/form'
// 组件class前缀
const prefixCls = 'pt-lab-test-platform-form'
const canNotDelete = ['ASA', 'PCR']
export default {
  name: 'pt-lab-test-platform-form',
  mixins: [formMixins],
  computed: {
    classes () {
      return `${prefixCls}`
    },
    disabled () {
      if (canNotDelete.includes(this.form.name) && this.isEdit) {
        return true
      }
      return false
    }
  },
  props: {
    value: {
      type: Object,
      default: () => {}
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      form: JSON.stringify(this.value) !== '{}' ? this.value : {
        dayType: 'WORK_DAY',
        name: ''
      }
    }
  },
  watch: {
    form: {
      handler: function (val) {
        this.$emit('input', val)
      },
      deep: true
    },
    value: {
      handler: function (val) {
        this.form = val
      },
      deep: true
    }
  },
  methods: {
    // changeData (data) {
    //   if (data.testCycle) {
    //     data.cycle = data.testCycle.replace(/[^0-9]/ig, '')
    //   }
    //   return data
    // }
  }
}
</script>
<style lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-lab-test-platform-form{
  margin-bottom: 20px;
  .el-input{
    max-width: 280px;
  }
  .el-input.small-input{
    max-width: 180px;
  }
  .marginLeft{
    margin-left: 20px;
  }
}

</style>
